module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAMFJREFUSA3tVO0NAiEMfRjXcB8nkTHULUTd4wZyDkUIlDbNXbwccInJ8actlPf6lQL/fgwn8DwC73uwD3y3SHsBxgKnIf7eMcTnFvRa8AgXMLwjXEHgW4ATbsESBPTWVu4ZzoR+eDZhRX/E9aTq5OfitWYGhTQr4xFpr1+2KJF23UqUKlJRonk9WnOKvJr7eRHq0dB29wx6EYSNmk4PgryuE8HUFF0Be8lBVImxDJqBq8ji1LgmUStgMh9n0jYpK/AFtHgfZQ/MTvgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Blue/Chat.png
// module id = 656
// module chunks = 0